import { useEffect, useState } from "react";
import { Col, Container, Form, Offcanvas, Row, Spinner } from "react-bootstrap";
import { studyEventManagementServices } from "../../../../APIServices/CTMS/EventManagement/studyEventManagementServices";
import { studySubjectManagementServices } from "../../../../APIServices/CTMS/SubjectManagement/studySubjectManagementServices";
import { studySiteManagementServices } from "../../../../APIServices/CTMS/SiteManagement/studySiteManagementServices";
import { useParams } from "react-router";
import { studyLevelFormManagementServices } from "../../../../APIServices/studyLevelFormManagementServices";

const FilterMedicalTask = ({
  Show,
  Hide,
  Title,
  siteId,
  setSiteId,
  subjectId,
  setSubjectId,
  eventId,
  setEventId,
  timePointId,
  setTimePointId,
  loading,
  setFormId,
  formId,
  getSubjectMedicalReviewTask,
}) => {
  const [siteList, setSiteList] = useState([]);
  const [subjectList, setSubjectList] = useState([]);
  const [eventList, setEventList] = useState([]);
  const [formList, setFormList] = useState([]);
  let { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const LoginCat = JSON.parse(localStorage.getItem("role")).toLowerCase();

  const getStudySiteBasedonAccess = async () => {
    let data = await studySiteManagementServices.getStudySiteBasedonAccess(studyId, LoginCat, StudyMode)
    setSiteList(data?.data || [])
  }

  const getStudySubjectRowData = async () => {
    let data = await studySubjectManagementServices.getStudySubjectRowData("active", studyId, siteId, StudyMode)
    setSubjectList(data?.data || [])
  }

  const getStudyEventRowData = async () => {
    let data = await studyEventManagementServices.getStudyEventRowData("active", studyId)
    setEventList(data?.data || [])
  }

  const getStudyLevelForm = async () => {
    let data = await studyLevelFormManagementServices.getStudyLevelForm(studyId, "edc", "active", StudyMode)
    setFormList(data?.data || [])
  }

  useEffect(() => {
    getStudySiteBasedonAccess()
    getStudyEventRowData()
    getStudyLevelForm()
  }, []);

  useEffect(() => {
    if (siteId) {
      getStudySubjectRowData();
    }
  }, [siteId]);
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title} by selection</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Container fluid>
            <Row className="mb-2">
              <Form.Group as={Col} md={4} className="text-end">
                <Form.Label>Site:</Form.Label>
              </Form.Group>
              <Form.Group as={Col} md={8}>
                <Form.Select onChange={(e) => setSiteId(e.target.value)}>
                  <option value="">Select Site</option>
                  {siteList?.map((siteData) => (
                    <option
                      selected={siteId === siteData?.siteId}
                      value={siteData?.siteId}
                    >
                      {siteData?.row?.SITEID}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group as={Col} md={4} className="text-end">
                <Form.Label>Subject:</Form.Label>
              </Form.Group>
              <Form.Group as={Col} md={8}>
                <Form.Select onChange={(e) => setSubjectId(e.target.value)}>
                  <option value="">Select Subject</option>
                  {subjectList?.map((subjectData) => (
                    <option
                      selected={subjectId === subjectData}
                      value={subjectData?.subjectId}
                    >
                      {subjectData?.row?.SUBJECTID ||
                        subjectData?.row?.RANDOMNUMBER ||
                        subjectData?.row?.SCREENID}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group as={Col} md={4} className="text-end">
                <Form.Label>Event:</Form.Label>
              </Form.Group>
              <Form.Group as={Col} md={8}>
                <Form.Select
                  onChange={(e) => {
                    setEventId(e.target.value);
                    setTimePointId(e.target[e.target.selectedIndex].id);
                  }}
                >
                  <option value="">Select Event</option>
                  {eventList?.map((eventData) => (
                    <option
                      selected={
                        `${eventId}${timePointId || ""}` ===
                        `${eventData?.eventId}${eventData?.row?.TIMEPOINTUNIQUEID || ""}`
                      }
                      value={eventData?.eventId}
                      id={eventData?.row?.TIMEPOINTUNIQUEID}
                    >
                      {eventData?.row?.EVENTID}{" "}
                      {eventData?.row?.TIMEPOINTUNIQUEID &&
                        `(${eventData?.row?.TIMEPOINTID})`}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group as={Col} md={4} className="text-end">
                <Form.Label>Form:</Form.Label>
              </Form.Group>
              <Form.Group as={Col} md={8}>
                <Form.Select onChange={(e) => setFormId(e.target.value)}>
                  <option value="">Select Form</option>
                  {formList?.map((formData) => (
                    <option
                      selected={formId === formData?.formId}
                      value={formData?.formId}
                    >
                      {formData?.formName}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Row>
          </Container>
        </Offcanvas.Body>
        <div className="border-top p-2 bg-light hstack gap-2 justify-content-end">
          <button
            onClick={() => {
              setSiteId("")
              setSubjectId("")
              setEventId("")
              setTimePointId("")
              setFormId("")
              getSubjectMedicalReviewTask()
              
            }}
            className="updateProfile">
            Reset
          </button>
          <button  onClick={getSubjectMedicalReviewTask} disabled={loading} className="updateProfile">
            {loading ? (
              <>
                <div className="hstack gap-2">
                  <Spinner size="sm" /> Filtering...
                </div>
              </>
            ) : (
              "Filter Now"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default FilterMedicalTask;
